import React,{useState,useEffect} from 'react'
import { useSelector } from "react-redux";

import AdSenseAd from './AdSenseAd';

function Googleadshorizontal({props}) {
  const [adIds, setAdIds] = useState([2974075987, 5093245935]);

  return (<>
      <AdSenseAd adSlot={adIds[Math.floor(Math.random() * 2)]} />
    </>
  )
}

export default Googleadshorizontal